import { EnvironmentProviders, Provider } from '@angular/core';
import { HttpLoopApiAuthInterceptor } from '@shared/interceptors/http-loop-api-auth.interceptor';
import { HttpApiAppDataInterceptor } from '@shared/interceptors/http-api-app-data.interceptor';
import { HttpResponseInterceptor } from '@shared/interceptors/http-response.interceptor';
import { ErrorClientAppNotSupportedInterceptor } from '@shared/interceptors/errors/error-client-app-not-supported.interceptor';
import { ErrorPayloadTooLargeInterceptor } from '@shared/interceptors/errors/error-payload-too-large.interceptor';
import { ErrorNotFoundInterceptor } from '@shared/interceptors/errors/error-not-found.interceptor';
import { ErrorActionNotPermittedInterceptor } from '@shared/interceptors/errors/error-action-not-permitted.interceptor';
import { HttpProxyHelperInterceptor } from 'web/app/interceptors/http-proxy-helper.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorBadRequestInterceptor } from '@shared/interceptors/errors/error-bad-request.interceptor';
import { ErrorExpiredAccessTokenInterceptor } from '@shared/interceptors/errors/error-expired-access-token.interceptor';

export const INTERCEPTOR_PROVIDERS: (Provider | EnvironmentProviders)[] = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: HttpLoopApiAuthInterceptor,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: HttpProxyHelperInterceptor,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: HttpApiAppDataInterceptor,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: HttpResponseInterceptor,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorClientAppNotSupportedInterceptor,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorPayloadTooLargeInterceptor,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorNotFoundInterceptor,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorActionNotPermittedInterceptor,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorBadRequestInterceptor,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorExpiredAccessTokenInterceptor,
    multi: true
  }
];
